import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _styled from "@emotion/styled-base";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { ProgressTracker, Stages } from '@atlaskit/progress-tracker';
import { N60 } from '@atlaskit/theme/colors';
import React, { useEffect, useState } from 'react';

var Line = _styled("div", {
  target: "e17rk6sg0",
  label: "Line"
})("height:2px;background:", N60, ";margin-top:24px;margin-bottom:24px;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

var stageNames = ['Details', 'Discount', 'Timeframe', 'Review'];

var PromotionSteps = function PromotionSteps(_ref) {
  var currentStage = _ref.currentStage;

  var _useState = useState(currentStage),
      _useState2 = _slicedToArray(_useState, 2),
      maxStageVisited = _useState2[0],
      setMaxStage = _useState2[1];

  var stages = stageNames.map(function (stageName, index) {
    return {
      id: index + 1,
      label: stageName,
      percentageComplete: 0,
      status: 'unvisited'
    };
  });
  useEffect(function () {
    if (maxStageVisited < currentStage) {
      setMaxStage(currentStage);
    }
  }, [currentStage]);

  var getCurrentStages = function getCurrentStages() {
    return stages.map(function (stage) {
      var status = stage.status;
      var percentageComplete = stage.percentageComplete;

      if (stage.id <= maxStageVisited) {
        status = 'visited';
      }

      if (stage.id < maxStageVisited) {
        percentageComplete = 100;
      }

      if (stage.id === currentStage) {
        status = 'current';
      }

      return _objectSpread(_objectSpread({}, stage), {}, {
        status: status,
        percentageComplete: percentageComplete
      });
    });
  };

  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ProgressTracker, {
    items: getCurrentStages()
  }), /*#__PURE__*/React.createElement(Line, null));
};

export default PromotionSteps;